import { useForm } from "react-hook-form"
import { useNavigate, useSearchParams } from "react-router"
import { api, ApiError } from "../../lib/api"
import appName from "../../lib/appName"
import "../../styles/auth.scss"

type FormValues = {
  password: string
  password_confirmation: string
}

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get("reset_password_token") ?? ""

  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>()

  const onSubmit = async (data: FormValues) => {
    try {
      await api.put("/users/password", {
        user: {
          reset_password_token: token,
          password: data.password,
          password_confirmation: data.password_confirmation,
        },
      })
      navigate("/")
    } catch (err) {
      const { data: errData } = err as ApiError
      const message = errData.errors?.[0] ?? "エラーが発生しました"
      setError("root", { message })
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt={appName()} className="auth-logo__img" />
        </div>

        <h1 className="auth-title">新しいパスワードを設定</h1>
        <p className="auth-subtitle">新しいパスワードを入力してください</p>

        {errors.root && (
          <div className="error-banner">{errors.root.message}</div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label>新しいパスワード</label>
            <input
              type="password"
              placeholder="8文字以上"
              className={errors.password ? "error" : ""}
              {...register("password", {
                required: "パスワードを入力してください",
                minLength: { value: 8, message: "パスワードは8文字以上で入力してください" },
              })}
            />
            {errors.password && <p className="field-error">{errors.password.message}</p>}
          </div>

          <div className="form-group">
            <label>新しいパスワード（確認）</label>
            <input
              type="password"
              placeholder="もう一度入力"
              className={errors.password_confirmation ? "error" : ""}
              {...register("password_confirmation", {
                required: "確認用パスワードを入力してください",
                validate: (v) => v === watch("password") || "パスワードが一致しません",
              })}
            />
            {errors.password_confirmation && (
              <p className="field-error">{errors.password_confirmation.message}</p>
            )}
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? "変更中..." : "パスワードを変更する"}
          </button>
        </form>
      </div>
    </div>
  )
}
